import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";
import { moodSmileIcon } from "../../../MapMarkerIcons/MapMarkerIcons";



export function VisitasPorSemanaPersonalViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const apellido = record[1] as string;
    const nombre = record[2] as string;
    const puesto = record[3] as string;

    const color = theme.colors.green[6];
    const icon = moodSmileIcon;

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: color,
    }

    return markerProps;
}